/* tslint:disable */
/* eslint-disable */
/**
 * WSK APIドキュメント
 *  WSK APIドキュメント  ## レスポンス形式 - result     - **status**：     - **message**：     - **system_date**：     - **pageno**： - data     - list         - **datacount**：         - **maxcount**：         - **list**：   ### result.status - **success**：正常終了 - **error**：入力エラー、権限エラー - **warning**：警告で、通知する必要のあるメッセージがある - **info**：正常処理で、通知する必要のあるメッセージがある  
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 出荷数量21
 * @export
 * @interface Col21
 */
export interface Col21 {
}

/**
 * Check if a given object implements the Col21 interface.
 */
export function instanceOfCol21(value: object): value is Col21 {
    return true;
}

export function Col21FromJSON(json: any): Col21 {
    return Col21FromJSONTyped(json, false);
}

export function Col21FromJSONTyped(json: any, ignoreDiscriminator: boolean): Col21 {
    return json;
}

export function Col21ToJSON(json: any): Col21 {
    return Col21ToJSONTyped(json, false);
}

export function Col21ToJSONTyped(value?: Col21 | null, ignoreDiscriminator: boolean = false): any {
    return value;
}

